<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#7bff76" type="timer" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<mat-card class="form-card ggPrompt">
  <mat-card-title>BRD CPC Diary Report </mat-card-title>
  <span>ข้อมูล {{ dateLabel }}</span>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">

    <input type="hidden" formControlName="id" required>

    <mat-form-field appearance="fill">
      <mat-label>%Trash วันนี้</mat-label>
      <input matInput formControlName="trash_today_brr" required>
      <mat-error *ngIf="form.get('trash_today_brr')?.hasError('required')">
        กรุณากรอก %Trash วันนี้
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>%Trash สะสม</mat-label>
      <input matInput formControlName="trash_brr" required>
      <mat-error *ngIf="form.get('trash_brr')?.hasError('required')">
        กรุณากรอก %Trash สะสม
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>%น้ำตาลรวมต่ออ้อย วันนี้ </mat-label>
      <input matInput formControlName="sugarperton_today_brr" required>
      <mat-error *ngIf="form.get('sugarperton_today_brr')?.hasError('required')">
        กรุณากรอก %น้ำตาลรวมต่ออ้อย วันนี้
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>%น้ำตาลรวมต่ออ้อย สะสม </mat-label>
      <input matInput formControlName="sugarperton_brr" required>
      <mat-error *ngIf="form.get('sugarperton_brr')?.hasError('required')">
        กรุณากรอก %น้ำตาลรวมต่ออ้อย สะสม
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>%น้ำตาล/CCS วันนี้</mat-label>
      <input matInput formControlName="sugarperccs_today_brr" required>
      <mat-error *ngIf="form.get('sugarperccs_today_brr')?.hasError('required')">
        กรุณากรอก %น้ำตาล/CCS วันนี้
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>%น้ำตาล/CCS สะสม</mat-label>
      <input matInput formControlName="sugarperccs_brr" required>
      <mat-error *ngIf="form.get('sugarperccs_brr')?.hasError('required')">
        กรุณากรอก %น้ำตาล/CCS สะสม
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>หนี้ค้าง(รวม ราย)</mat-label>
      <input matInput formControlName="outstandingDebt_target" required>
      <mat-error *ngIf="form.get('outstandingDebt_target')?.hasError('required')">
        กรุณากรอก หนี้ค้าง(รวม ราย)
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>หนี้ค้าง แก่ไขแล้ว วันนี้(ราย)</mat-label>
      <input matInput formControlName="outstandingDebt_today" required>
      <mat-error *ngIf="form.get('outstandingDebt_today')?.hasError('required')">
        กรุณากรอก หนี้ค้าง แก่ไขแล้ว วันนี้(ราย)
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>หนี้ค้าง แก่ไขแล้ว สะสม(ราย)</mat-label>
      <input matInput formControlName="outstandingDebt_amount" required>
      <mat-error *ngIf="form.get('outstandingDebt_amount')?.hasError('required')">
        กรุณากรอก หนี้ค้าง แก่ไขแล้ว สะสม(ราย)
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>สูญเสียจากการตัด(เป้าหมาย กก./ไร่)</mat-label>
      <input matInput formControlName="lossCutting_target" required>
      <mat-error *ngIf="form.get('lossCutting_target')?.hasError('required')">
        กรุณากรอก สูญเสียจากการตัด(เป้าหมาย กก./ไร่)
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>สูญเสียจากการตัด(สะสม กก./ไร่)</mat-label>
      <input matInput formControlName="lossCutting" required>
      <mat-error *ngIf="form.get('lossCutting')?.hasError('required')">
        กรุณากรอก สูญเสียจากการตัด(สะสม กก./ไร่)
      </mat-error>
    </mat-form-field>

    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
      บันทึกข้อมูล
    </button>
  </form>
</mat-card>
